import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Record<
	'banner' | 'editDraft' | 'finishLater' | 'morePublishActions' | 'publish' | 'publishError',
	MessageDescriptor
> = defineMessages({
	banner: {
		id: 'hub-app-shell.migration-review-action-bar.banner',
		defaultMessage: 'Previewing your help center draft',
		description: 'Banner text that explains an administrator is previewing a help center draft.',
	},
	editDraft: {
		id: 'hub-app-shell.migration-review-action-bar.editDraft',
		defaultMessage: 'Edit draft',
		description: 'Menu item that returns the administrator to editing the help center draft.',
	},
	finishLater: {
		id: 'hub-app-shell.migration-review-action-bar.finishLater',
		defaultMessage: 'Finish later',
		description:
			'Menu item that asks the administrator to confirm finishing the help center review later.',
	},
	morePublishActions: {
		id: 'hub-app-shell.migration-review-action-bar.morePublishActions',
		defaultMessage: 'More publish actions',
		description: 'Accessible label for the overflow button next to the Publish action.',
	},
	publish: {
		id: 'hub-app-shell.migration-review-action-bar.publish',
		defaultMessage: 'Publish',
		description: 'Primary button that starts publishing the help center draft.',
	},
	publishError: {
		id: 'hub-app-shell.migration-review-action-bar.publishError.ai-non-final',
		defaultMessage: 'Unable to publish your help center. Try again.',
		description:
			'Error flag shown when publishing the migrated help center fails and the administrator can retry.',
	},
});

export default messages;
